import Vue from "vue";

import "./styles/quasar.sass";
import lang from "quasar/lang/pt-br.js";
import "@quasar/extras/material-icons/material-icons.css";
import {
  Quasar,
  QLayout,
  QHeader,
  QDrawer,
  QPageContainer,
  QPage,
  QToolbar,
  QToolbarTitle,
  QBtn,
  QIcon,
  QList,
  QItem,
  QItemSection,
  QItemLabel,
  QFab,
  QFabAction,
  QSpinnerCube,
  QSelect,
  QInput,
  Ripple
} from "quasar";

Vue.use(Quasar, {
  config: {},
  components: {
    QLayout,
    QHeader,
    QDrawer,
    QPageContainer,
    QPage,
    QToolbar,
    QToolbarTitle,
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemSection,
    QItemLabel,
    QFab,
    QFabAction,
    QSpinnerCube,
    QSelect,
    QInput
  },
  directives: {
    Ripple
  },
  plugins: {},
  lang: lang
});
